import { render, staticRenderFns } from "./EBook.vue?vue&type=template&id=3522998f&scoped=true&xmlns%3Av-clipboard=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./EBook.vue?vue&type=script&lang=js&"
export * from "./EBook.vue?vue&type=script&lang=js&"
import style0 from "./EBook.vue?vue&type=style&index=0&id=3522998f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3522998f",
  null
  
)

export default component.exports